import React, { useState, useEffect, useContext } from "react";
import { apiPut, apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { AiFillEdit, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { isEmpty, startCase } from "lodash";
import helper from "../../utils/helpers";
import useToastContext from "hooks/useToastContext";
import AdsView from "./AdsView";
import userPng from "../../assets/images/user.png";
import OImage from "components/reusable/OImage";
import Pagination from "pages/Pagination";
import SliderSettingEdit from "./SliderSettingEdit";

const SliderSetting = ({ addSlider, manager }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const permission = user?.permission?.find(
    (e) => e.manager === "ads_and_banner_manager",
  );

  const notification = useToastContext();
  const [Banner, setBanner] = useState([]);
  const [showViewModal, setShowModal] = useState(false);
  const [BannerItem, setBannerItem] = useState({});
  const [showEditModal, setEditModal] = useState(false);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [page, setPage] = useState(1);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };
  const getAllBanners = async () => {
    try {
      const path = apiPath.sliderSetting;
      const result = await apiGet(path);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;

      setBanner(response);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response?.page : null,
        pageCount: resultStatus ? response?.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };
  useEffect(() => {
    if (!addSlider.var) getAllBanners();
  }, []);

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeSliderSettingStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getAllBanners();
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  const toggleViewModal = (item) => {
    setBannerItem(item);
    setShowModal(!showViewModal);
  };
  const toggleEditModal = (item) => {
    setBannerItem(item);
    setEditModal(!showEditModal);
  };

  return (
    <div className="p-3">
      <div className="p-2">
        {(user?.role === "admin" || permission?.add) && (
          <button
            title="Add Property Category"
            type="button"
            className="bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap"
            onClick={() => setEditModal(true)}
          >
            + {t("ADD_SLIDER_SETTING")}
          </button>
        )}
      </div>
      <div
        className="overflow-x-auto relative 
 border"
      >
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer ">
                <div className="flex  ">
                  <span>{t("O_BANNER_PICTURE")} </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer ">
                <div className="flex  ">
                  <span>{t("O_CATEGORY")} </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer">
                <div className="flex">
                  <span>{t("O_BANNER_DESCRIPTION")} </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer">
                <div className="flex">
                  <span>{t("O_BANNER_DESCRIPTION") + t("O_ARABIC")} </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer text-right">
                <div className="flex justify-end">
                  {" "}
                  <span>{t("O_POSTED_AT")} </span>{" "}
                </div>
              </th>
              {(manager?.add || user?.role === "admin") && (
                <th scope="col" className="py-3 px-6 text-center">
                  {" "}
                  {t("O_STATUS")}{" "}
                </th>
              )}
              <th scope="col" className="py-3 px-6 text-center">
                {" "}
                {t("O_ACTION")}{" "}
              </th>
            </tr>
          </thead>
          <tbody>
            {Banner &&
              Banner?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1}
                  </th>
                  <td className="py-3 px-6 border-r text-center">
                    <figure className="inline-block overflow-hidden rounded-full border-2 mb-0">
                      <OImage
                        src={item?.bannerImage}
                        fallbackUrl={userPng}
                        className="w-10 h-10"
                      />
                    </figure>
                  </td>
                  <td className="py-2 px-2 border-r">
                    {item?.category ?? "N/A"}
                  </td>
                  <td className="py-2 px-2 border-r">{item?.description}</td>
                  <td className="py-2 px-2 border-r">{item?.descriptionAr}</td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-2 px-2 border-r text-center">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? "active" : "inactive"
                              } slider?`,
                              item,
                              handelStatusChange,
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  <td className="py-4 px-6 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        {(manager?.add ||
                          user?.role === "admin" ||
                          permission?.add) && (
                          <li
                            onClick={() => toggleEditModal(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <button title={t("O_EDIT")}>
                              {" "}
                              <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </button>
                          </li>
                        )}
                        <li
                          onClick={() => toggleViewModal(item)}
                          className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                        >
                          <button title={t("O_VIEW")}>
                            {" "}
                            <AiFillEye className="w-5 h-5 text-slate-600" />{" "}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(Banner) && (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {paginationObj?.totalItems !== 0 && (
        <Pagination
          handlePageClick={handlePageClick}
          options={paginationObj}
          page={page}
        />
      )}

      {showViewModal && <AdsView onHide={toggleViewModal} item={BannerItem} />}
      {showEditModal && (
        <SliderSettingEdit
          bannerData={BannerItem}
          setBannerItem={setBannerItem}
          setEditModal={setEditModal}
          getAllBanners={getAllBanners}
        />
      )}
    </div>
  );
};

export default SliderSetting;
